import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue'),
      meta: {
        title: '呦步 - 首页',
        key: 'home', 
        description: '',
        keywords: ''
      }
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('../views/About.vue'),
      meta: {
        title: '关于我们 - 呦步',
        key: 'about', 
        description: '',
        keywords: ''
      }
    },
    {
      path: '/products',
      name: 'Products',
      component: () => import('../views/Products.vue'),
      meta: {
        title: '主营产品系列 - 呦步',
        key: 'products',
        description: '',
        keywords: ''
      }
    }, {
      path: '/detail',
      name: 'ProductsDetail',
      component: () => import('../views/Detail.vue'),
      meta: {
        title: '主营产品系列详情 - 呦步',
        key: 'products',
        description: '',
        keywords: ''
      }
    },
    {
      path: '/knowledge',
      name: 'Knowledge',
      component: () => import('../views/Knowledge.vue'),
      meta: {
        title: '足踝健康科普 - 呦步',
        key: 'knowledge',
        description: '',
        keywords: ''
      }
    },
    {
      path: '/scenarios',
      name: 'Scenarios',
      component: () => import('../views/Scenarios.vue'),
      meta: {
        title: '应用场景 - 呦步',
        key: 'scenarios',
        description: '',
        keywords: ''
      }
    },
 {
      path: '/scenariosDetail',
      name: 'scenariosDetail',
      component: () => import('../views/ScenariosDetail.vue'),
      meta: {
        title: '详情 - 呦步',
        key: 'scenarios',
        description: '',
        keywords: ''
      }
    },
    
    {
      path: '/customization',
      name: 'Customization',
      component: () => import('../views/Customization.vue'),
      meta: {
        title: '一站式定制 - 呦步',
        key: 'customization',
        description: '',
        keywords: ''
      }
    },
    {
      path: '/news',
      name: 'News',
      component: () => import('../views/News.vue'),
      meta: {
        title: '新闻活动 - 呦步',
        key: 'news',
        description: '',
        keywords: ''
      }
    },
    {
      path: '/stores',
      name: 'Stores',
      component: () => import('../views/Stores.vue'),
      meta: {
        title: '门店分布 - 呦步',
        key: 'stores',
        description: '',
        keywords: ''
      }
    },
    {
      path: '/join',
      name: 'Join',
      component: () => import('../views/Join.vue'),
      meta: {
        title: '加入呦步 - 呦步',
        key: 'join',
        description: '',
        keywords: ''
      }
    },
    // 可以添加一个404页面重定向
    {
      path: '*',
      redirect: '/'
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 添加滚动行为配置
  scrollBehavior() {
    return { x: 0, y: 0 } // 返回顶部
  }
})

// 路由守卫：动态修改标题
router.beforeEach((to, from, next) => {
  console.log(from)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router